import { render, staticRenderFns } from "./UploadCollection.vue?vue&type=template&id=7e471124&scoped=true&"
import script from "./UploadCollection.vue?vue&type=script&lang=js&"
export * from "./UploadCollection.vue?vue&type=script&lang=js&"
import style0 from "./UploadCollection.vue?vue&type=style&index=0&id=7e471124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e471124",
  null
  
)

export default component.exports